export default __webpack_public_path__ + "static/media/segre01.28ec9fd7.jpg";